import {fetchUtils} from 'react-admin';
import {stringify} from 'query-string';
import {o} from 'odata';
import _ from 'lodash';
import {convertFileToBase64} from "./b64toBiteArray";
import moment from 'moment';
import { XMLParser } from 'fast-xml-parser';

//const httpClient = fetchUtils.fetchJson;
export const httpClient = (url, options = {}) => {
    const apiUrl = `${localStorage.getItem('domain')}/odata/`;
    if (!options.headers) {
        options.headers = new Headers({ Accept: 'application/json' });
    }
    const token = localStorage.getItem('token');
    const company = localStorage.getItem('company');
    options.headers.set('Authorization', `Bearer ${token}`);
    options.headers.set('Bypass-Tunnel-Reminder', "true");

    // add your own headers here
    options.headers.set('X-COMPANY', options.x_company||company);
    return fetchUtils.fetchJson(apiUrl+url, options);
}

const oConfig = (c)=>{
    const token = localStorage.getItem('token');
    const company = c||localStorage.getItem('company');
    return {

        headers: new Headers({
            "Content-Type": "application/json",
            "X-COMPANY": company,
            'Authorization': `Bearer ${token}`,
            'Bypass-Tunnel-Reminder': "true"
        }),
    }}

export const oHandler = () => o(`${localStorage.getItem('domain')}/odata/`,oConfig());
export default {
    getList: (resource, params) => {
        //console.log({resource, params})
       // console.log('filter',resource,params)
      //  const { page, perPage } = params.pagination;
       // const { field, order } = params.sort;
        params = params || {}
        params.filter = params.filter || {}
        const {expand,filter,queryString, select} = params.filter
        const {sort,pagination} = params;
       
        console.log('getList',resource,params)
           // console.log('getting',params)
        // const query = {
        //     // sort: JSON.stringify([field, order]),
        //     // range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
        //     // filter: JSON.stringify(params.filter),
        //     $count: true
        // };
        //const url = `${apiUrl}/${resource}?${stringify(query)}`;

        // return httpClient(url).then(({ headers, json }) => ({
        //         //     data: json.value,
        //         //     total: json['@odata.count']
        //         // }));
        const query = {}
        query.$count =  true
//        query.company=1
       if(expand)
       {
           query.$expand  = expand
       }
        if(select)
        {
            query.$select  = select
        }
        if(!select && resource==="employees") {
            query.$select = 'fullname,startDate,contractEndDate,orgID,name,fatherName,gFatherName,tinNo,pensionNo,companyBankId,bankBranch,bankAccountHolderName,employmentType,defaultOvertime,siteId,dateOfBirth,isSiteManager,citizenship,gender,outstandingLoan,remainingLeaveDays,basicSalary,basicCurrency,newBasicSalaryStartDate,prevBasicSalary,salaryAdjustmentRemarks,positionId,departmentId,costCenterId,bankAccountNumber,bank,defaultCurrency,mateId,active,excludeFromDistEarnings,sendPayslipVia,payGross,otBase,desiredNet,dailyServiceHour,nationalID,taxRegion,grade,function,step,program,subFunction,companyId,id,address,isDeleted,extraIncomeTax,customIncomeTaxExpression'

        }
       if(filter)
       {
 
           query.$filter = filter
       }
       if(sort && sort.order && !queryString ) {
        //   console.log(sort)
           query.$orderby = `${sort.field} ${sort.order.toLowerCase()}`
       }

       if(pagination && pagination.perPage && !queryString) {
           query.$skip = pagination.perPage * (pagination.page-1)
           query.$top = pagination.perPage
       }

       if(params.filter && !queryString)
       {
           const keys =  Object.keys(_.omit(params.filter, ["expand","filter","queryString","q", "select"]));
           keys.map((k,index)=>{
               let val = params.filter[k];
            //    console.log(k,val)
               // If the value is a string and looks like an OData literal, do not wrap in quotes
               if (typeof val === 'string' && val.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/)) {
                     val = moment(val).startOf('day').toISOString();
               } else if (typeof val === 'string') {
                   val = `'${val}'`;
               }
               if(!query.$filter)
               {
                   query.$filter = `${k} eq ${val}`
               }
               else {
                   query.$filter += ` and ${k} eq  ${val}`
               }

           })
          // console.log(query.$filter)
       }
       //console.log(params)


       // return oHandler()
       //      .get(resource)
       //      .fetch(query).then(response => {
       //             if (response.status >= 200 && response.status <= 299) {
       //
       //                 return response.json().then(d => (
       //                     {
       //                         data: d.value,
       //                         total: d['@odata.count']
       //                     }))
       //             }
       //             else {
       //
       //                 throw Error({status:response.status})
       //
       //             }
       //
       //         }
       //
       //     )
      let q = stringify(query)
        if(queryString){
          q=  q+"&"+queryString
        }
       // console.log(`${resource}?${q}`)
         return   httpClient(`${resource}?${q}`,{x_company:params.company}).then(({ json }) => {
             // console.log(json)
             if(json) {
                 return {
                     data: json.value,
                     total: json['@odata.count']
                 }
             }
         })


    },

    getOne: (resource, params) =>
     {
       //  console.log('gettingOne',resource)
         const query = {}
         // if(resource==='employees')
         // {
         //     params.expand = 'address'
         // }
         const {expand,id} = params



         if(expand)
         {
             query.$expand  = expand
         }


         return oHandler()
             .get(`${resource}(${id})`)
             .query(query).then(data =>
                 {


                     return {data}

                 }




             )


        //  return   httpClient(`${apiUrl}/${resource}(${params.id})?${stringify(query)}`).then(({ json }) => ({
        //     data: json,
        // }))

     },

    getMany: (resource, params) => {
        
       let expand  = params && params.filter && params.filter.expand
            console.log('xx',params)
        const query = {
            $filter: `id in (${params.ids.join(',')})`,
            $expand: expand
        };
        // console.log("getting many", params)

        if(resource==="payrolls")
        {
            query.$expand = 'payrollRun'
        }
       
    

        const url = `${resource}?${stringify(query)}`;
        return httpClient(url).then(({ json }) => ({ data: json.value }));
    },

    getManyReference: (resource, params) => {
        const { page, perPage } = params.pagination;
        const { sort} = params;
      //  console.log("sort",sort)
    //  console.log('geting many ref',params)
        const query = {
            // sort: JSON.stringify([field, order]),
            // range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
            // filter: JSON.stringify({
            //     ...params.filter,
            //     [params.target]: params.id,
            // }),
            $expand:resource,
           // company:1

        };
        const expandParams = [];
        if(sort && sort.order && sort.field!=='id' ) {
            //   console.log(sort)
            expandParams.push(`$orderby=${sort.field} ${sort.order.toLowerCase()}`)
          //  query.$orderby = ``
        }

        if(params.filter && params.filter.oFilter){
            //query.$filter =  params.filter.oFilter

            expandParams.push(`$filter=${params.filter.oFilter}`)
        }
        if(expandParams.length)
        {
            query.$expand += `(${expandParams.join()})`
        }

        const url = `${params.target}(${params.id})?${stringify(query)}`;

        return httpClient(url).then(({ headers, json }) =>  {
const res = json[resource].map(r=>({...r,parent:_.omit(json,resource)}))

            return {
            data: res,
            total: json[resource].length
        }});
    },

    update: (resource, params) =>
        // httpClient(`${apiUrl}/${resource}(${params.id})`, {
        //     method: 'PUT',
        //     body: JSON.stringify(params.data),
        // }).then(({ json }) => ({ data: json }))
        //
  {



      const data =  _.omit(params.data, ["id","deductions", "earnings", "createdDate", "createdBy",'modifiedBy',"modifiedDate", "version", "@odata.context", "@odata.etag","parent" ])  // (({id, createdDate, modifiedDate,version,'@odata.context' ...others}) => ({...others}))(params.data)
     // console.log(resource)


      if(resource==="companies") {

          if(data.logo&& data.logo.rawFile instanceof File){
             return convertFileToBase64(data.logo).then(res=>{
                 data.logo = res;
                 return oHandler().patch(`${resource}(${params.id})`,data).query().then(res => ({data:res}))

                 //   console.log(res)
             })
          }

        //   console.log({data})

          if(data.stamp&& data.stamp.rawFile instanceof File){
            return convertFileToBase64(data.stamp).then(res=>{
                data.stamp = res;
                return oHandler().patch(`${resource}(${params.id})`,data).query().then(res => ({data:res}))

                //   console.log(res)
            })
         }

      }

      if(resource==="users") {

        if(data.signatureImage&& data.signatureImage.rawFile instanceof File){
           return convertFileToBase64(data.signatureImage).then(res=>{
               data.signatureImage = res;
               return oHandler().patch(`${resource}(${params.id})`,data).query().then(res => ({data:res}))

               //   console.log(res)
           })
        }

        if(data.profilePicture&& data.profilePicture.rawFile instanceof File){
          return convertFileToBase64(data.profilePicture).then(res=>{
              data.profilePicture = res;
              return oHandler().patch(`${resource}(${params.id})`,data).query().then(res => ({data:res}))

              //   console.log(res)
          })
       }

    }

      // if(data.address && data.address.phoneNumber)
      // {
      //      data.address.phoneNumber = data.address.phoneNumber.map(p=>_.omit(p, ["id" ]))  // (({id, createdDate, modifiedDate,version,'@odata.context' ...others}) => ({...others}))(params.data)
      //
      // }


      //console.log(data)
    //  else {
          return oHandler().patch(`${resource}(${params.id})`, data).query().then(res => ({data: res}))
     // }
}
    ,

    updateMany: (resource, params) => {

        const data =  _.omit(params.data, ["id", "createdDate", "createdBy",'modifiedBy',"modifiedDate", "version", "@odata.context", "@odata.etag" ])  // (({id, createdDate, modifiedDate,version,'@odata.context' ...others}) => ({...others}))(params.data)

        return Promise.all(params.ids.map(function (id) {
            return oHandler().patch(`${resource}(${id})`,data).query().then(res => ({data:res}))
        })).then(function (responses) { return ({ data: responses.map(function (_a) {
                //var json = _a.json;
                return _a.data;
            }) }); });
    },

    create: (resource, params) =>
     {
         const query = {
            //company: 1
         };

         return httpClient(`${resource}?${stringify(query)}`, {

            method: 'POST',
            body: JSON.stringify(params.data),
        }).then(({ json }) => ({
            data: { ...params.data, id: json.id },
        }))},

    delete: (resource, params) =>
        httpClient(`${resource}(${params.id})`, {
            method: 'DELETE',
        }).then(({ json }) => ({ data: json || {id:params.id} })),

    deleteMany: (resource, params) => {

        return Promise.all(params.ids.map(function (id) {
            return oHandler().delete(`${resource}(${id})`,params.data).query()
        })).then(function (responses) { return ({ data: responses.map(function (_a) {
               // const json = _a.json;
                return { data: _a}
            }) }); });



    },

    serverAction: (resource, params) => {
      return  httpClient(`${resource}(${params.id})/${params.action}`, {
            method: 'POST',
            body: JSON.stringify(params.data),
        })
            .then(({ json }) => ({ data: json }));
    },

    serverActionMany: (resource, params) => {
        return Promise.all(params.ids.map(function (id) {
            return  httpClient(`${resource}(${id})/${params.action}`, {
                method: 'POST',
                body: JSON.stringify(params.data),
            })
                .then(({ json }) => ({ data: json }));
        })).then(function (responses) { return ({ data: responses.map(function (_a) {
                //var json = _a.json;
                return _a.data;
            }) }); });
    },

    serverCollectionAction: (resource, params) => {
        return  httpClient(`${resource}/${params.action}`, {
            method: 'POST',
            body: JSON.stringify(params.data),
        })
            .then(({ json }) => ({ data: json }));
    },

    get: (path,params) => {
        const query = {
            //company: 1
        };
         return   httpClient(`${path}?${stringify(query)}`).then(({ json }) => ({
            data: json,
        }))
    },

    createMany: (resource, params) => {
        const promises = params.data.map(item => 
            httpClient(resource, {
                method: 'POST',
                body: JSON.stringify(item),
            })
        );

        return progressPromise(promises, params.onProgress).then(responses => ({ 
            data: responses.map(response => ({ data: response.json }))
        }));
    }
};

const progressPromise = (promises, onProgress) => {
    let completed = 0;
    const total = promises.length;
    
    // Wrap each promise to report progress
    const wrappedPromises = promises.map(promise => 
        promise.then(result => {
            completed++;
            onProgress&&onProgress(completed, total);
            return result;
        })
    );
    
    return Promise.all(wrappedPromises);
};

/**
 * Fetch and parse OData $metadata, returning a schema map for entities.
 * @returns {Promise<Object>} Map of entity name to { fields, navigation, enums }
 */
export async function fetchODataSchema() {
    const apiUrl = `${localStorage.getItem('domain')}/odata/$metadata`;
    const token = localStorage.getItem('token');
    const headers = new Headers({
        Accept: 'application/xml',
        Authorization: `Bearer ${token}`,
        'Bypass-Tunnel-Reminder': "true"
    });
    const res = await fetch(apiUrl, { headers });
    const xml = await res.text();
    const parser = new XMLParser({ ignoreAttributes: false, attributeNamePrefix: "@_" });
    const json = parser.parse(xml);
    // Find EntityTypes and EnumTypes
    const schemas = {};
    const enumTypes = new Set();
    const edmx = json['edmx:Edmx'] || json['Edmx'];
    if (!edmx) return schemas;
    const dataServices = edmx['edmx:DataServices'] || edmx['DataServices'];
    if (!dataServices) return schemas;
    const schemasArr = Array.isArray(dataServices.Schema) ? dataServices.Schema : [dataServices.Schema];
    schemasArr.forEach(schema => {
        // Collect EnumTypes
        if (schema.EnumType) {
            const enums = Array.isArray(schema.EnumType) ? schema.EnumType : [schema.EnumType];
            enums.forEach(e => {
                if (e['@_Name']) {
                    enumTypes.add((schema['@_Namespace'] ? schema['@_Namespace'] + '.' : '') + e['@_Name']);
                }
            });
        }
        // EntityTypes and ComplexTypes
        const processType = (typeElement, isEntity = false) => {
            const typeName = typeElement['@_Name'];
            const fields = {};
            const navigation = {};
            // Properties
            const props = Array.isArray(typeElement.Property) ? typeElement.Property : (typeElement.Property ? [typeElement.Property] : []);
            props.forEach(prop => {
                const type = prop['@_Type'];
                const isCollection = type && type.startsWith('Collection(');
                const isComplex = type && !type.startsWith('Edm.') && !enumTypes.has(type.replace(/^Collection\((.*)\)$/,'$1'));
                const isEnum = enumTypes.has(type.replace(/^Collection\((.*)\)$/,'$1'));
                fields[prop['@_Name']] = {
                    type,
                    required: prop['@_Nullable'] === 'false',
                    isEnum,
                    isCollection,
                    isComplex
                };
            });
            // NavigationProperties (only for EntityTypes)
            if (isEntity) {
                const navs = Array.isArray(typeElement.NavigationProperty) ? typeElement.NavigationProperty : (typeElement.NavigationProperty ? [typeElement.NavigationProperty] : []);
                navs.forEach(nav => {
                    const type = nav['@_Type'];
                    const isCollection = type && type.startsWith('Collection(');
                    const isComplex = type && !type.startsWith('Edm.');
                    navigation[nav['@_Name']] = {
                        type,
                        isCollection,
                        isComplex
                    };
                });
            }
            schemas[typeName] = { fields, navigation };
        };

        // Process EntityTypes
        if (schema.EntityType) {
            const entityTypes = Array.isArray(schema.EntityType) ? schema.EntityType : [schema.EntityType];
            entityTypes.forEach(entity => processType(entity, true));
        }

        // Process ComplexTypes
        if (schema.ComplexType) {
            const complexTypes = Array.isArray(schema.ComplexType) ? schema.ComplexType : [schema.ComplexType];
            complexTypes.forEach(complex => processType(complex, false));
        }
    });
    return { schemas, enumTypes };
}
